// plan-02 S02: 30-FPS capped frame scheduler — bible S13B

export type DrawPass = (
  ctx: CanvasRenderingContext2D,
  w: number,
  h: number,
  t: number,
) => void

const FRAME_MS = 33 // ~30 FPS

export function createLoop(
  ctx: CanvasRenderingContext2D,
  getSize: () => { w: number; h: number },
  passes: DrawPass[],
): { start: () => void; stop: () => void } {
  let running = false
  let rafId = 0
  let lastFrame = 0

  function tick(now: number): void {
    if (!running) return
    rafId = requestAnimationFrame(tick)
    const elapsed = now - lastFrame
    if (elapsed < FRAME_MS) return
    lastFrame = now - (elapsed % FRAME_MS)

    const { w, h } = getSize()
    ctx.clearRect(0, 0, w, h)
    for (let i = 0; i < passes.length; i++) {
      passes[i](ctx, w, h, now / 1000)
    }
  }

  return {
    start(): void {
      if (running) return
      running = true
      rafId = requestAnimationFrame(tick)
    },
    stop(): void {
      running = false
      cancelAnimationFrame(rafId)
    },
  }
}
